import { render } from "./MypageSelectTabs.vue?vue&type=template&id=31ab74a0&scoped=true&ts=true"
import script from "./MypageSelectTabs.vue?vue&type=script&lang=ts"
export * from "./MypageSelectTabs.vue?vue&type=script&lang=ts"

import "./MypageSelectTabs.vue?vue&type=style&index=0&id=31ab74a0&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ab74a0"]])

export default __exports__